import React from "react";
import Highcharts, { Options } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { ChartBarleySoftWheat } from "../../../redux/actions/dashboard/dashboardTypes";

const DynamicChartCountActions = (
  dynamicChart: ChartBarleySoftWheat[],
  t: (arg0: string) => string,
  cropName: string
) => {
  const chartOptions: Options = {
    colors: ["#7BB4EC", "#50B432"],
    chart: {
      type: "column",
    },
    title: {
      text: t("Dashboard.cereal_charts.distribution_by_variety"),
    },

    series: [
      {
        name: t("Dashboard.number_of_actions"),
        data: dynamicChart.map((u: ChartBarleySoftWheat) => u?.actions),
      } as any,
    ],
    yAxis: {
      title: {
        text: "",
      },
    },
    xAxis: {
      categories: dynamicChart.map((u: ChartBarleySoftWheat) => u.variety),
    },
  };
  return (
    <HighchartsReact
      containerProps={{
        style: {
          width: "100%",
        },
      }}
      highcharts={Highcharts}
      options={chartOptions}
    />
  );
};

export default DynamicChartCountActions;
